import styles from './StatsBar.module.scss';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
    selectRmInvestigationData,
    selectRmStatsReporting
} from 'selectors/selectors';
import RmStatsCheckboxes from './RmStatsCheckboxes';
import { checkNullReturnZero } from 'utils/common';

const statsDisplayConfig = [
    {
        title: 'S1 Risk Score (#Rank)',
        investigationTitle: 'Scenario 1',
        key: 's1'
    },
    {
        title: 'S2 Risk Score (#Rank)',
        investigationTitle: 'Scenario 2',
        key: 's2'
    },
    {
        title: 'S3 Risk Score (#Rank)',
        investigationTitle: 'Scenario 3',
        key: 's3'
    },
    {
        title: 'S4 Risk Score (#Rank)',
        investigationTitle: 'Scenario 4',
        key: 's4'
    },
    { title: 'Correlation Risk Score' }
];

const RmStats = () => {
    const rmStats = useSelector(selectRmStatsReporting);
    const investigationData = useSelector(selectRmInvestigationData);
    const { editable, rmInvestigations } = { ...investigationData };

    return (
        <>
            {rmStats &&
                statsDisplayConfig.map((stat, idx) => (
                    <div
                        className={styles.stat}
                        key={`${stat.title}-stat-${idx}`}
                    >
                        <div className={styles.value}>
                            <div className={styles.main}>
                                {stat.title === 'Correlation Risk Score'
                                    ? `${checkNullReturnZero(
                                          rmStats.correlationScore
                                      )}`
                                    : `${checkNullReturnZero(
                                          rmStats[`${stat.key}Score`]
                                      )}`}
                            </div>
                            {stat.title !== 'Correlation Risk Score' && (
                                <div className={styles.percentage}>
                                    {`#${checkNullReturnZero(
                                        rmStats[`${stat.key}Rank`]
                                    )}`}
                                </div>
                            )}
                        </div>
                        <div className={styles.description}>{stat.title}</div>
                        {stat.investigationTitle && rmInvestigations && (
                            <div
                                className={
                                    styles.scenarioInvestigationContainer
                                }
                            >
                                <div
                                    disabled={!editable}
                                    className={styles.scenarioText}
                                >
                                    {stat.investigationTitle}
                                </div>
                                <RmStatsCheckboxes index={idx} />
                            </div>
                        )}
                    </div>
                ))}
        </>
    );
};

RmStats.propTypes = {
    data: PropTypes.shape({})
};
export default RmStats;
